export default "__VITE_ASSET__HHkMUlaA__"